import { useState, useEffect } from "react";
import MKTypography from "components/MKTypography";
import MKBox from "components/MKBox";
import CircularProgress from "@mui/material/CircularProgress";
import { creditService } from "services/creditService";
import PropTypes from "prop-types";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";
import Card from "@mui/material/Card";

function UserCredits({ id }) {
  const [credits, setCredits] = useState(0);
  const [loading, setLoading] = useState(true);
  const [amount, setAmount] = useState(0);
  const [checked, setChecked] = useState(false);

  const fetchCredits = async () => {
    try {
      setLoading(true);
      const credits = await creditService.getBalanceByUserId(id);
      setCredits(credits.amount);
    } catch (error) {
      console.error("Error fetching credits:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await creditService.addOrSubtractCreditsAdmin(amount, id);
      fetchCredits();
      setAmount(0);
      setChecked(false);
    } catch (error) {
      console.error("Error adding or subtracting credits:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAmountChange = (e) => {
    const value = parseInt(e.target.value);
    setAmount(value);
    setChecked(false);
  };

  const handleChecked = (e) => {
    setChecked(e.target.checked);
  };

  const handleCancel = () => {
    setAmount(0);
    setChecked(false);
  };

  useEffect(() => {
    fetchCredits();
  }, [id]);

  return (
    <>
      <MKBox component="section" py={3}>
        <MKTypography variant="h4">Credits</MKTypography>
        <MKTypography variant="body2" marginBottom={2}>
          Deze gebruiker heeft <strong>{loading ? <CircularProgress size={12} /> : credits}</strong>{" "}
          gesprekken met de chatbot tegoed.
        </MKTypography>
        <MKBox component="section">
          <Card sx={{ width: "100%", mt: 4 }}>
            <Grid
              container
              item
              justifyContent="center"
              xs={10}
              lg={7}
              mx="auto"
              textAlign="center"
              p={3}
            >
              <MKTypography variant="h4">Credits toevoegen of aftrekken</MKTypography>
              <MKTypography variant="body2" marginBottom={2}>
                Voer het aantal credits in dat je wilt toevoegen. Als je een negatief getal invult,
                wordt het aantal credits afgetrokken.
              </MKTypography>
              <MKBox component="form" autoComplete="off" onSubmit={handleSubmit} p={3} width="80%">
                <MKInput
                  type="number"
                  inputProps={{
                    step: "1",
                    min: "-999999",
                    max: "999999",
                  }}
                  value={amount}
                  onChange={handleAmountChange}
                  fullWidth
                  variant="standard"
                  placeholder="Aantal credits"
                  sx={{
                    "& .MuiInput-root": {
                      fontSize: "16px",
                      padding: "12px 0",
                    },
                    "& input": {
                      textAlign: "center",
                    },
                  }}
                />
                <Grid item xs={12} alignItems="center" ml={-1} mt={2}>
                  <Switch checked={checked} onChange={handleChecked} />
                  <MKTypography variant="button">
                    Ik weet zeker dat ik <strong>{Math.abs(amount)}</strong> credits wil{" "}
                    <strong>{amount >= 0 ? "toevoegen" : "aftrekken"}</strong>
                  </MKTypography>
                </Grid>
                <Grid container item xs={12} alignItems="center" ml={-1} mt={2} spacing={2}>
                  <Grid item xs={12} md={6}>
                    <MKButton variant="outlined" color="dark" onClick={handleCancel} fullWidth>
                      Annuleren
                    </MKButton>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MKButton
                      variant="contained"
                      color="dark"
                      onClick={handleSubmit}
                      fullWidth
                      disabled={!checked || loading || amount === 0}
                    >
                      Uitvoeren
                    </MKButton>
                  </Grid>
                </Grid>
              </MKBox>
            </Grid>
          </Card>
        </MKBox>
      </MKBox>
    </>
  );
}

export default UserCredits;

UserCredits.propTypes = {
  id: PropTypes.string.isRequired,
};
